
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Gateway from '~/components/Gateway.vue';
import Home from '~/components/Home/index.vue';
import ModulesLayout from '~/components/ModulesLayout.vue';
import RoomsLayout from '~/components/RoomsLayout.vue';
import TheLeftPanel from '~/components/TheLeftPanel.vue';
import User from '~/components/User/index.vue';
import { beforeUpdateAndEnter } from '~/guards/SupportPanelGuard';
import { LayoutModule } from '~/store/modules/layout';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
]);

@Component({
    components: {
        TheLeftPanel,
        Home,
        User,
        Gateway,
        RoomsLayout,
        ModulesLayout,
    },
})
export default class ThaLayoutSupport extends Mixins(DarkThemeInfoMixin) {
    @Prop() readonly isUserInfoShown!: string;
    @Prop() readonly userIdentifier!: string;
    @Prop() readonly homeId!: string;
    @Prop() readonly gatewayId!: string;
    @Prop() readonly moduleId!: string;

    expandRooms = true

    async beforeRouteEnter(to: any, from: any, next: any) {
        await beforeUpdateAndEnter(to, from, next);
    }
    async beforeRouteUpdate(to: any, from: any, next: any) {
        await beforeUpdateAndEnter(to, from, next);
    }
    setRoomModeActive(value: boolean) {
        LayoutModule.setRoomModeActive(value);
    }
    get isRoomModeActive() {
        return LayoutModule.isRoomModeActive;
    }

    setExpandRoom() {
        this.expandRooms = !this.expandRooms;
    }
}
